import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";
import {ContactGalleryFragment} from "./fragments/ContactGallery";

export const GET_PROVIDER_EVENTS_BY_DISTRICT = gql`
  query GetProviderEventsByDistrict {
    getProviderEventsByDistrict {
      id
      name
      providerUrl
      headerPicture {
        ...imageFields
      }
      offers {
        id
        offerType
        name
      }
      contactGallery {
        ...contactGalleryFields
      }
    }
  }
  ${ImageFragment}
  ${ContactGalleryFragment}
`;


